<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal hide-footer id="award-book-view-modal" size="lg" title="Award Book View">

      <div class="modal-content bg-white rounded box-shadow">
        <table class="table table-centered table-striped">
          <tr>
            <th>Name</th>
            <td>{{ award_book.name }}</td>
          </tr>
          <tr>
            <th>Father`s Name</th>
            <td>{{ award_book.fathers_name }}</td>
          </tr>
          <tr>
            <th>Book No.</th>
            <td>{{ award_book.book_no }}</td>
          </tr>
          <tr>
            <th>Sub Book No.</th>
            <td>{{ award_book.sub_book_no }}</td>
          </tr>
          <tr>
            <th>Total Land</th>
            <td>{{ award_book.total_land }}</td>
          </tr>
          <tr>
            <th>Amount</th>
            <td>{{ award_book.amount }}</td>
          </tr>
          <tr>
            <th>Award Book Type</th>
            <td>{{ award_book.award_book_type ? award_book.award_book_type.award_book_type_desc : '' }}</td>
          </tr>
          <tr>
            <th>Award Book E Type</th>
            <td>{{ award_book.award_book_e_type ? award_book.award_book_e_type.award_book_e_type_desc : '' }}</td>
          </tr>
          <tr>
            <th>Field Book No.</th>
            <td>{{ award_book.field_book_no }}</td>
          </tr>
          <tr>
            <th>Mouza</th>
            <td>{{ award_book.mouza ? award_book.mouza.mouza_desc : '' }}</td>
          </tr>
          <tr>
            <th>Plot No.</th>
            <td>{{ award_book.plot_schedule ? award_book.plot_schedule.plot_no : ''}}</td>
          </tr>
          <tr>
            <th>Remarks</th>
            <td>{{ award_book.remarks }}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>


export default {
  name: "viewAwardBookModal",
  props: ['award_book'],
  components: {},
  data() {
    return {

    };
  },

  mounted() {

  },
  methods: {

  },
};
</script>
